<script lang="ts">
  import { PUBLIC_DO_SCRIPTS_URL } from '$env/static/public';
</script>

<svelte:head>
  <script src="{PUBLIC_DO_SCRIPTS_URL}/lottie/5.12.2/lottie.min.js" referrerpolicy="no-referrer"></script>
</svelte:head>
